import { withCharge, withAdmin } from "../components/Admin";
import { AdminLayout } from "../layouts";
import {
  UsersAdmin,
  CategoriesAdmin,
  ProductAdmin,
  ExtrasAdmin,
  OffersAdmin,
  TablesAdmin,
  OrdersAdmin,
  ExternalOrdersAdmin,
  TableDetailsAdmin,
  TableMenuCategories,
  TableMenuProducts,
  TableMenuCart,
  PaymentsHistory,
  DailySummary,
  DashboardReport,
  CashAdmin,
  CashCharge,
  CashHistory,
  ProductSalesReport,
  PeakHoursReport,
  LossesReport,
  SiteConfigAdmin,
  InvoicingAdmin,
  TipsAdmin,
  TipSettlementsReport,
  ModulesAdmin,
  ComprobantesReport,
  PaymentQrAdmin,
  KitchenScreen,
  ToServeScreen,
  PrepTimesReport,
  CancellationsReport,
  CustomersAdmin,
  HelpAdmin,
  BackupAdmin,
} from "../pages/Admin";

const routesAdmin = [
  {
    path: "/admin",
    layout: AdminLayout,
    component: OrdersAdmin,
    exact: true,
  },
  {
    path: "/admin/customers",
    layout: AdminLayout,
    component: withAdmin(CustomersAdmin),
    exact: true,
  },
  {
    path: "/admin/cancellations",
    layout: AdminLayout,
    component: withAdmin(CancellationsReport),
    exact: true,
  },
  {
    path: "/admin/prep-times",
    layout: AdminLayout,
    component: withAdmin(PrepTimesReport),
    exact: true,
  },
  {
    path: "/admin/external",
    layout: AdminLayout,
    component: ExternalOrdersAdmin,
    exact: true,
  },
  {
    path: "/admin/kitchen",
    layout: AdminLayout,
    component: KitchenScreen,
    exact: true,
  },
  {
    path: "/admin/to-serve",
    layout: AdminLayout,
    component: ToServeScreen,
    exact: true,
  },
  {
    path: "/admin/users",
    layout: AdminLayout,
    component: withAdmin(UsersAdmin),
    exact: true,
  },
  {
    path: "/admin/categories",
    layout: AdminLayout,
    component: withAdmin(CategoriesAdmin),
    exact: true,
  },
  {
    path: "/admin/products",
    layout: AdminLayout,
    component: withAdmin(ProductAdmin),
    exact: true,
  },
  {
    path: "/admin/extras",
    layout: AdminLayout,
    component: withAdmin(ExtrasAdmin),
    exact: true,
  },
  {
    path: "/admin/offers",
    layout: AdminLayout,
    component: withAdmin(OffersAdmin),
    exact: true,
  },
  {
    path: "/admin/tables",
    layout: AdminLayout,
    component: withAdmin(TablesAdmin),
    exact: true,
  },
  {
    path: "/admin/table/:id",
    layout: AdminLayout,
    component: TableDetailsAdmin,
    exact: true,
  },
  {
    path: "/admin/table/:id/menu",
    layout: AdminLayout,
    component: TableMenuCategories,
    exact: true,
  },
  {
    path: "/admin/table/:id/menu/cart",
    layout: AdminLayout,
    component: TableMenuCart,
    exact: true,
  },
  {
    path: "/admin/table/:id/menu/:idCategory",
    layout: AdminLayout,
    component: TableMenuProducts,
    exact: true,
  },
  {
    path: "/admin/cash-charge",
    layout: AdminLayout,
    component: withCharge(CashCharge),
    exact: true,
  },
  {
    path: "/admin/cash",
    layout: AdminLayout,
    component: withCharge(CashAdmin),
    exact: true,
  },
  {
    path: "/admin/cash-history",
    layout: AdminLayout,
    component: withCharge(CashHistory),
    exact: true,
  },
  {
    path: "/admin/dashboard",
    layout: AdminLayout,
    component: withAdmin(DashboardReport),
    exact: true,
  },
  {
    path: "/admin/payments-history",
    layout: AdminLayout,
    component: withAdmin(PaymentsHistory),
    exact: true,
  },
  {
    path: "/admin/daily-summary",
    layout: AdminLayout,
    component: withAdmin(DailySummary),
    exact: true,
  },
  {
    path: "/admin/product-sales",
    layout: AdminLayout,
    component: withAdmin(ProductSalesReport),
    exact: true,
  },
  {
    path: "/admin/peak-hours",
    layout: AdminLayout,
    component: withAdmin(PeakHoursReport),
    exact: true,
  },
  {
    path: "/admin/losses",
    layout: AdminLayout,
    component: withAdmin(LossesReport),
    exact: true,
  },
  {
    path: "/admin/comprobantes",
    layout: AdminLayout,
    component: withCharge(ComprobantesReport),
    exact: true,
  },
  {
    path: "/admin/tip-settlements",
    layout: AdminLayout,
    component: withCharge(TipSettlementsReport),
    exact: true,
  },
  {
    path: "/admin/tips",
    layout: AdminLayout,
    component: withAdmin(TipsAdmin),
    exact: true,
  },
  {
    path: "/admin/invoicing",
    layout: AdminLayout,
    component: withAdmin(InvoicingAdmin),
    exact: true,
  },
  {
    path: "/admin/site-config",
    layout: AdminLayout,
    component: withAdmin(SiteConfigAdmin),
    exact: true,
  },
  {
    path: "/admin/payment-qr",
    layout: AdminLayout,
    component: withAdmin(PaymentQrAdmin),
    exact: true,
  },
  {
    path: "/admin/help",
    layout: AdminLayout,
    component: HelpAdmin,
    exact: true,
  },
  {
    path: "/admin/modules",
    layout: AdminLayout,
    component: withAdmin(ModulesAdmin),
    exact: true,
  },
  {
    path: "/admin/backup",
    layout: AdminLayout,
    component: withAdmin(BackupAdmin),
    exact: true,
  },
];

export default routesAdmin;
